




import { defineComponent } from '@nuxtjs/composition-api'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default defineComponent({
  name: 'BaseLightBox',

  components: {
    CoolLightBox,
  },

  inheritAttrs: false,
})
